// The anonymous identity (plan.md §5, §6).
//
// A UUID minted in the browser and kept in localStorage. Be clear about what
// this is: it is sent with every write and verified by nothing. Clearing
// storage or opening a private window mints a fresh one.
//
// So it is a UX guard, not a security control. It stops accidental
// double-taps and casual repeat-clicking, and it powers "my reports" without
// a login. It does not stop a determined or scripted abuser, and nothing
// built on it will (plan.md §6).

const KEY = 'reporter.session_token';

function mint() {
  if (globalThis.crypto?.randomUUID) return crypto.randomUUID();
  // Older Safari. Not security-relevant — see the note above.
  return 'sess-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

let cached = null;

export function getSessionToken() {
  if (cached) return cached;
  try {
    let token = localStorage.getItem(KEY);
    // create_report and log_corroboration both reject tokens under 16 chars.
    if (!token || token.length < 16) {
      token = mint();
      localStorage.setItem(KEY, token);
    }
    cached = token;
    return token;
  } catch {
    // Private mode with storage blocked: fall back to a per-tab token. The
    // user can still report and corroborate; they just lose "my reports"
    // when the tab closes.
    cached ??= mint();
    return cached;
  }
}

export function hasPersistentSession() {
  try {
    return Boolean(localStorage.getItem(KEY));
  } catch {
    return false;
  }
}
